import { render } from "./BillGenerate.vue?vue&type=template&id=bf59eb4c&scoped=true"
import script from "./BillGenerate.vue?vue&type=script&lang=js"
export * from "./BillGenerate.vue?vue&type=script&lang=js"

import "./BillGenerate.vue?vue&type=style&index=0&id=bf59eb4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf59eb4c"]])

export default __exports__